// Double submit: Express requires the XSRF-TOKEN cookie value in this header on every /api call.
// Every new call to Express outside ApiClientBase and the global axios must send it too.
export const XSRF_COOKIE_NAME = 'XSRF-TOKEN';
export const XSRF_HEADER_NAME = 'X-XSRF-TOKEN';

export function getXsrfToken(): string | undefined {
  const prefix = `${XSRF_COOKIE_NAME}=`;
  const cookie = document.cookie.split(';').map((c) => c.trim()).find((c) => c.startsWith(prefix));

  return cookie ? decodeURIComponent(cookie.substring(prefix.length)) : undefined;
}

// Read on every request: the token changes after logout or session invalidation.
export function getXsrfHeaders(): Record<string, string> {
  const token = getXsrfToken();

  return token ? { [XSRF_HEADER_NAME]: token } : {};
}

export function withXsrfHeader<T extends { headers?: any }>(request: T): T {
  const headers = getXsrfHeaders();
  if (Object.keys(headers).length) {
    request.headers = request.headers ?? {};
    Object.assign(request.headers, headers);
  }

  return request;
}
